let navigateFunction = null;

export const setNavigate = (navFn) => {
  navigateFunction = navFn;
};

export const getNavigate = () => {
  if (!navigateFunction) {
    throw new Error("Navigate function not set");
  }
  return navigateFunction;
};
